import { useEffect, useState } from 'react';

import {
  MIN_TERMINAL_BUTTONS,
  MIN_MAX_BUTTONS,
  getPageNumbers,
} from '../utils/pagination';

const usePagination = ({
  activePage,
  maxButtons,
  terminalButtons,
  totalPages,
}: {
  activePage: number;
  maxButtons: number;
  terminalButtons: number;
  totalPages: number;
}): number[] => {
  const [maxButtonsDisplayed, setMaxButtonsDisplayed] = useState<number>();
  const [terminalButtonsDisplayed, setTerminalButtonsDisplayed] =
    useState<number>();

  const updateButtonsDisplayedFromWindowSize = () => {
    const isSmallerThanTablet = window?.innerWidth < 768;
    if (isSmallerThanTablet) {
      setMaxButtonsDisplayed(MIN_MAX_BUTTONS);
      setTerminalButtonsDisplayed(MIN_TERMINAL_BUTTONS);
    } else {
      setMaxButtonsDisplayed(maxButtons);
      setTerminalButtonsDisplayed(terminalButtons);
    }
  };

  useEffect(() => {
    setMaxButtonsDisplayed(Math.max(maxButtons, MIN_MAX_BUTTONS));
    setTerminalButtonsDisplayed(
      Math.max(terminalButtons, MIN_TERMINAL_BUTTONS)
    );
  }, [maxButtons, terminalButtons]);

  useEffect(() => {
    updateButtonsDisplayedFromWindowSize();
    window?.addEventListener('resize', updateButtonsDisplayedFromWindowSize);
    return () => {
      window?.removeEventListener(
        'resize',
        updateButtonsDisplayedFromWindowSize
      );
    };
  }, []);

  return getPageNumbers({
    activePage,
    maxButtons: maxButtonsDisplayed,
    terminalButtons: terminalButtonsDisplayed,
    totalPages,
  });
};

export default usePagination;
